import lurkerSend, { lurkerSendBeacon } from './helper'

const setDataToString = (extraData = {}) => {
  const data = {}
  Object.keys(extraData).forEach(k => {
    if (typeof extraData[k] === 'object') {
      data[k] = JSON.stringify(extraData[k])
    } else if (typeof extraData[k] !== 'undefined') {
      data[k] = `${extraData[k]}`
    }
  })
  return data
}

const round = number => Math.round(number * 1000) / 1000

class Lurker {
  constructor(pageName, publicAccountId) {
    this.pageName = pageName
    this.publicAccountId = publicAccountId
  }

  getElapsedTime = () =>
    this.initialLoadTime && round((new Date().getTime() - this.initialLoadTime) / 1000)

  setPublicAccountId = publicAccountId => {
    this.publicAccountId = publicAccountId
  }

  pageLoadEvt = (pageName, extraData) => {
    if (pageName) {
      this.pageName = pageName
    }
    this.initialLoadTime = new Date().getTime()
    lurkerSend({
      event_type: 'page_view',
      object_detail: 'load',
      object_name: this.pageName,
      ...(this.publicAccountId && { public_account_id: this.publicAccountId }),
      ...extraData,
    })
  }

  pageLoadWithExtraDataEvt = (pageName, extraData) => {
    if (pageName) {
      this.pageName = pageName
    }
    this.initialLoadTime = new Date().getTime()
    lurkerSend(
      setDataToString({
        event_type: 'page_view',
        object_detail: 'load',
        object_name: this.pageName,
        ...(this.publicAccountId && { public_account_id: this.publicAccountId }),
        ...extraData,
      })
    )
  }

  // Only string values are allowed
  _baseClickEvt = (trackingCallback, detail, extraData) =>
    trackingCallback(
      setDataToString({
        ...extraData,
        event_type: 'click',
        object_detail: detail,
        object_name: this.pageName,
        accounts_elapsed_time: this.getElapsedTime(),
        ...(this.publicAccountId && { public_account_id: this.publicAccountId }),
      })
    )

  clickEvt = (detail, extraData) => this._baseClickEvt(lurkerSend, detail, extraData)

  clickBeaconEvt = (detail, extraData) => this._baseClickEvt(lurkerSendBeacon, detail, extraData)

  // Only string values are allowed
  viewMessageEvt = (detail, extraData) =>
    lurkerSend(
      setDataToString({
        ...extraData,
        event_type: 'message_view',
        object_detail: detail,
        object_name: this.pageName,
        accounts_elapsed_time: this.getElapsedTime(),
        ...(this.publicAccountId && { public_account_id: this.publicAccountId }),
      })
    )

  redirectEvt = (detail, extraData) =>
    lurkerSend(
      setDataToString({
        ...extraData,
        event_type: 'message_view',
        object_detail: detail,
        object_name: this.pageName,
        accounts_elapsed_time: this.getElapsedTime(),
        ...(this.publicAccountId && { public_account_id: this.publicAccountId }),
      })
    )

  /**
   * Sends an error message event with detailed information for lurker tracking.
   *
   * @param {string} objectName - The name of the object related to the error event.
   * @param {Object} extraData - Additional data to include in the event payload.
   * @returns {*} The result of the lurkerSend function.
   */
  errorMessageEvt = (objectName, extraData) =>
    lurkerSend(
      setDataToString({
        ...extraData,
        event_type: 'message_view',
        object_detail: 'error',
        object_name: objectName,
        accounts_elapsed_time: this.getElapsedTime(),
        ...(this.publicAccountId && { public_account_id: this.publicAccountId }),
      })
    )

  /**
   * Tracks an error event by sending relevant data to the lurker service.
   *
   * @param {Object} params - The parameters for tracking the error.
   * @param {string} params.objectName - The name of the object related to the error.
   * @param {string} params.objectDetail - Detailed information about the object.
   * @param {string} params.eventType - The type of event to track.
   * @param {Object} [params.extraData={}] - Additional data to include in the event.
   * @returns {void}
   */
  trackError = ({ objectName, objectDetail, eventType, extraData = {} }) =>
    lurkerSend(
      setDataToString({
        ...extraData,
        event_type: eventType,
        object_detail: objectDetail,
        object_name: objectName,
        accounts_elapsed_time: this.getElapsedTime(),
        ...(this.publicAccountId && { public_account_id: this.publicAccountId }),
      })
    )
}

export default Lurker
